import { combineReducers } from 'redux';

import getReserveHistoryReducer from './getReserveHistoryReducer';
import putCancelReserveReducer from './putCancelReserveReducer';
import putRemoveWaitCancelReducer from './putRemoveWaitCancelReducer';

const index = combineReducers({
  getReserveHistory: getReserveHistoryReducer,
  putCancelReserve: putCancelReserveReducer,
  putRemoveWaitCancel: putRemoveWaitCancelReducer,
});

export default index;
